import { isPlatformBrowser } from '@angular/common';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { throwError } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/operators';
import { CountryService } from 'src/app/customcomponents/site-context-selector/country.service';
import { CookieService } from 'src/app/customServices/cookie.service';

@Injectable()
export class HttpStoreInterceptor implements HttpInterceptor {
  countryIsoCode: string;
  country: any;
  currencyCode: any;
  queryParams: {};
  customerId: string = `customerIdNA`;
  modifiedReq: HttpRequest<any>;
  isCustomerIdCookieSet: any;
  platformId = inject(PLATFORM_ID);
  constructor(
    private authService: AuthService,
    private countryService: CountryService,
    private router: Router,
    private cookieService: CookieService,
    private globalMessageService: GlobalMessageService
  ) {
    this.countryService.getActive().subscribe((res) => (this.countryIsoCode = res));
  }

  intercept(request: HttpRequest<any[]>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isBrowser = isPlatformBrowser(this.platformId);
    this.isCustomerIdCookieSet = this.cookieService.isCookieSet(this.customerId);
    const customerIdValue = this.cookieService.getCookieValue(this.customerId);

    let modifiedReq = request;
    if (isBrowser && this.countryIsoCode) {
      modifiedReq = modifiedReq.clone({
        params: modifiedReq.params.set('store', this.countryIsoCode),
      });
      if (request?.url?.includes('/nominatim.openstreetmap.org')) {
        modifiedReq = modifiedReq.clone({
          params: modifiedReq.params.set('countrycodes', this.countryIsoCode),
        });
      }
    }

    // Add the 'unit' parameter if the customer ID cookie is set and the URL does not contain 'cms/pages'
    if (this.isCustomerIdCookieSet && !request.url?.includes('cms/pages')
      && !request.url?.includes('cms/components') && !request.url?.includes('cms/kbcomponents')) {
      modifiedReq = modifiedReq.clone({
        params: modifiedReq.params.set('unit', customerIdValue),
      });
    }
    return next.handle(modifiedReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.router.navigate(['/']);
        }
        else if (request.url.includes('logout')) {
          this.router.navigate(['/']);
          return throwError(error);
        } else if (request.url.includes('pages?') && error.status === 404) {
          if (isPlatformBrowser(this.platformId)) {
            window.location.replace('/');
          }
          return throwError(error);
        } else if (
          error.error?.errors?.[0]?.type === 'KbWrongCombinationError' ||
          error.error?.errors?.[0]?.type === 'UnsupportedCurrencyError'
        ) {
          this.countryService.setActive('US', 'error');
          if (isPlatformBrowser(this.platformId)) {
            window.location.replace('/');
          }
          return throwError(error);
        }
        if (error.error?.errors?.[0]?.type === 'InvalidTokenError') {
          this.cookieService.deleteCookie(this.customerId);
          this.authService.coreLogout();
          this.router.navigate(['/']);
          return throwError(error);
        }
        if (error.error?.errors?.[0]?.reason === 'cannotRestore') {
          this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
        }
        return throwError(error);
      })
    );
  }
}
